/*
 * 大型终端
 */
import React from 'react';
import cn from 'classnames';
import Scheme from 'components/product/scheme';
import Contact from 'components/contact';
import Wrapper from 'components/product/relevance/wrapper';
import MultipleBanner from 'components/product/banner/multiple';
import style from './index.module.scss';
import Medias from 'components/medias';

const IMG_PATH = 'https://sdk-source.xylink.com/website/assets/hardware/hard/AE800/';
const scene = [
  {
    title: '政务单位视频会商',
    pcUrl: IMG_PATH + 'scene-img3.jpg',
  },
  {
    title: '大型会议室商务洽谈',
    pcUrl: IMG_PATH + 'scene-img1.jpg',
  },
  {
    title: '集团全员型大会',
    pcUrl: IMG_PATH + 'scene-img2.jpg',
  },
  {
    title: '指挥调度中心',
    pcUrl: IMG_PATH + 'scene-img0.jpg',
  },
];
const AI = [
  {
    title: '支持人脸识别智能跟踪',
    pcUrl: IMG_PATH + 'AI-img1.jpg',
  },
  {
    title: '轻松实现电子铭牌、人脸签到、自动会议纪要',
    pcUrl: IMG_PATH + 'AI-img0.jpg',
  },
];
const features = [
  {
    name: '声音',
  },
  {
    name: '视频',
  },
  {
    name: '控制',
  },
  {
    name: '信令',
  },
  {
    name: '网络',
  },
  {
    name: '电源',
  },
];
const bannerList = [
  {
    title: '大型会议室\n全4K旗舰终端',
    pcUrl: 'bg-img3.jpg',
    mUrl: 'm/bg-img1.jpg',
    desc: '4K超高清画面细腻真实，带来一场大气磅礴的视听盛宴',
    mDesc: '4K超高清画面细腻真实，\n带来一场大气磅礴的视听盛宴',
    type: 4,
    className: style.firstBanner,
  },
  {
    title: '三屏4K，性能卓越',
    pcUrl: 'bg-img1.jpg',
    mUrl: 'm/bg-img2.jpg',
    desc: '支持三屏三显，双4K超高清显示\n全景、特写画面皆细腻清晰\n互动交流如身临现场',
    type: 3,
    className: style.banner1,
  },
  {
    title: '布局灵活，更佳应用',
    pcUrl: 'bg-img5.jpg',
    mUrl: 'm/bg-img3.jpg',
    desc: '支持多种画面布局\n满足多功能厅、报告厅、应急调度中心等多场景部署\n实现“相隔千里，如聚一室”',
    mDesc: '支持多种画面布局\n满足多功能厅、报告厅、应急调度中心等多\n场景部署\n实现“相隔千里，如聚一室”',
    type: 4,
  },
  {
    title: '国产芯片，超强稳定',
    pcUrl: 'bg-img0.jpg',
    mUrl: 'm/bg-img5.jpg',
    desc: '专业编解码处理芯片，运行安全可靠，视频协作稳如磐石\n支持H.265 SVC编解码，相同画质下可节约40%带宽资源',
    mDesc: '专业编解码处理芯片，运行安全可靠，视频协\n作稳如磐石\n支持H.265 SVC编解码，相同画质下可节约\n40%带宽资源',
    type: 3,
    className: style.banner2,
  },
  {
    title: '丰富接口，高效扩展',
    pcUrl: 'bg-img2.jpg',
    mUrl: 'm/bg-img4.jpg',
    desc: '提供丰富的音视频接口，满足会议室集成需求\n高效扩展各类办公协作场景',
    type: 4,
  },
];
const Ae800 = () => {
  return (
    <Wrapper title="大型终端" menuIndex="2" current={2} customClass={style.ae800}>
      {bannerList.map((item: any) => {
        return <MultipleBanner {...item} animate={'fadeIn'} delay={0.5} descCenter key={item.title} imageHost={IMG_PATH} className={cn(style.banner, item.className)} />;
      })}
      <Scheme animate="fadeIn" delay={0.5} data={AI} title={'AI功能，创意无限'} className={cn(style.ai)} />
      <Medias
        title={'极简部署，自由布线'}
        desc={'多媒体总线技术，音频、视频、控制、信令、\n网络、电源六流合一\n轻部署方式，布线便捷，网线连接扩展自由'}
        features={features}
        imgPre={IMG_PATH}
        bgImage={'bg-img4.jpg'}
        bgImageM={'m/bg-img6.jpg'}
      />
      <Scheme animate="fadeIn" delay={0.5} data={scene} title={'应用场景'} className={style.scene} />
      <Contact className={style.contact} btnType={'newBtn'} />
    </Wrapper>
  );
};

export default Ae800;
